export function fmtBudgetNum(n) {
  return Number(n ?? 0).toLocaleString("es-ES", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/** Unidades de prenda: enteros (sin decimales). */
export function fmtBudgetQty(n) {
  const x = Number(n ?? 0);
  if (!Number.isFinite(x)) return "0";
  return Math.round(x).toLocaleString("es-ES", {
    maximumFractionDigits: 0,
  });
}

export function fmtBudgetDate(d) {
  if (!d) return "—";
  try {
    const dt = typeof d === "string" ? new Date(d) : d;
    if (Number.isNaN(dt.getTime())) return String(d);
    return dt.toLocaleDateString("es-ES");
  } catch {
    return String(d);
  }
}

export function isPdfExt(s = "") {
  return /\.pdf(?:$|\?)/i.test(String(s));
}

export function looksImageExt(s = "") {
  return /\.(png|jpe?g|webp|gif|bmp|svg)(?:$|\?)/i.test(String(s));
}

export function getImageFormatFromDataUrl(dataUrl) {
  const m = /^data:image\/(png|jpeg|jpg|webp);/i.exec(dataUrl || "");
  if (!m) return "JPEG";
  const f = m[1].toUpperCase();
  return f.includes("PNG") ? "PNG" : f.includes("WEBP") ? "WEBP" : "JPEG";
}
